import { useState } from 'react'
import Image from 'next/image'
import styles from '@/styles/shared/BlurImage.module.css'

// Full-bleed photo that fills its positioned parent. Shows Sanity's tiny blurred preview
// straight away and fades the real photo in once it loads. Used by the home sliders and
// page backgrounds; they all use `sizes="100vw"`, so the same photo is only fetched once.
const BlurImage = ({ src, lqip, brightness, alt, position = 'center', preload = false }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div
      className={styles.wrapper}
      style={{
        filter: brightness ? `brightness(${brightness}%)` : undefined,
        backgroundImage: lqip ? `url(${lqip})` : undefined,
        backgroundPosition: position,
      }}
    >
      <Image
        src={src}
        alt={alt || ''}
        fill
        sizes="100vw"
        quality={75}
        preload={preload}
        onLoad={() => setIsLoaded(true)}
        className={`${styles.image} ${isLoaded ? styles.loaded : ''}`}
        style={{ objectPosition: position }}
      />
    </div>
  )
}

export default BlurImage
